"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REASONS = void 0;
var REASONS = _interopRequireWildcard(require("./reason-parts"));
exports.REASONS = REASONS;